import { useTranslation } from 'react-i18next';
import { Link } from 'wouter';
import { useAppPermissions } from '../../../shared/appUIFramework/appPermisions/useAppPermissions';
import { UserPermission } from '../../../shared/appUIFramework/appPermisions/userPermission';
import AppContentToolbar from '../../../shared/appUIFramework/components/AppContentToolbar';

export default function PaymentHeader({ activeTab }:{activeTab: 'overview' | 'payments' | 'terms'}) {
  const { t } = useTranslation();

  const { hasAnyOfPermissions } = useAppPermissions();
  const tabs = [];

  if (hasAnyOfPermissions(UserPermission.CanViewPaymentOverview)) {
    tabs.push({ title: t('Overview'), key: 'overview', to: '/payment/overview' });
  }

  if (hasAnyOfPermissions(UserPermission.CanMakePayments)) {
    tabs.push({ title: t('Payments'), key: 'payments', to: '/payment/payments' });
  }

  if (hasAnyOfPermissions(UserPermission.CanViewPaymentOverview)) {
    tabs.push({ title: t('TermsAndConditions'), key: 'terms', to: '/payment/terms' });
  }

  return (
    <>
      <AppContentToolbar>
        <span className="app-toolbar-breadcrumb">{ t('Navigation_Payment') }</span>
      </AppContentToolbar>
      <div className="app-tabs">
        { tabs.map(({ title, key, to }) => (
          <Link
            className={`app-tab ${key === activeTab ? 'app-tab-active' : ''}`}
            key={key}
            to={to}
          >
            { title }
          </Link>
        ))}
      </div>
    </>
  );
}
